export const selectFamily = (state) => state.view_family;

export const familyLoading = (state) => {
  const family = selectFamily(state);
  return family.isLoading;
};
